<template>
    <div>
        <textarea :readonly="readonly" :id="'ckeditor_'+ name">{{initialValue}}</textarea>
        <input type="hidden" :name="name" v-model="value"/>
    </div>
</template>
<script>
export default {
    props: {
        initialValue: {
            type: String,
            required: false,
            default: ''
        },
        name: {
            type: String,
            required: true
        },
        enableToolbar: {
            type: Boolean,
            default: true
        },
        readonly: {
            type: Boolean,
            default: false
        },
    },
    data() {
        return {
            config: {
                toolbar: [],
                toolbarGroups: [],
                throttle: 200,

            },
            component: null,
            value: '',
        }
    },
    mounted() {
        if (this.enableToolbar) {
            this.config.toolbar = [

                {
                    name: 'basicstyles',
                    groups: ['basicstyles', 'cleanup'],
                    items: ['Bold', 'Italic', 'Underline', 'Strike', 'Subscript', 'Superscript', '-', 'CopyFormatting', 'RemoveFormat']
                },
                {
                    name: 'paragraph',
                    groups: ['list', 'indent', 'align', 'bidi'],
                    items: ['NumberedList', 'BulletedList', '-', 'Outdent', 'Indent', '-', 'Blockquote', 'CreateDiv', '-', 'JustifyLeft', 'JustifyCenter', 'JustifyRight', 'JustifyBlock', '-', 'BidiLtr', 'BidiRtl']
                },
                {name: 'styles', items: ['Styles', 'Format', 'Font', 'FontSize']},
                {name: 'colors', items: ['TextColor', 'BGColor']},
                {name: 'tools', items: ['Maximize']},
            ];
        }
        this.component = CKEDITOR.replace('ckeditor_' + this.name, this.config);
        let app = this;
        app.value = this.initialValue
        this.component.on('change', function () {
            app.value = app.component.getData()
        });

    }
}
</script>

<style scoped>

</style>
